import { useInventoryStore } from '../store/inventoryStore'
import { useDeleteCategoryMutation } from '../hooks'
import type { ApiError } from '@/types/api'
import { Modal } from '@/components/custom/modal'
import LoadingButton from '@/components/custom/loading-button'
import { notifyRequestError } from '@/utils/notifyRequestError'

export function DeleteCategory({
  id,
  trigger,
  open,
  onClose,
}: {
  id: string | null
  trigger?: React.ReactNode
  open?: boolean
  onClose?: () => void
}) {
  const { mutateAsync: deleteCategoryMutation, isPending } =
    useDeleteCategoryMutation()

  const categories = useInventoryStore((s) => s.categories)
  const category = categories.find((u) => u._id === id)

  const handleDeleteItem = async () => {
    if (!category) return

    try {
      await deleteCategoryMutation(category._id)
      onClose?.()
    } catch (error) {
      notifyRequestError(error as ApiError, 'Failed to delete category')
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      trigger={trigger}
      title="Delete Category"
    >
      <div className="space-y-4">
        <p>
          Are you sure you want to delete category{' '}
          <strong>{category?.name}</strong>
          ?
          <br />
          <span className="text-red-500 font-semibold">
            This action is permanent and cannot be undone.
          </span>
        </p>
        <LoadingButton
          type="submit"
          className="w-full"
          isLoading={isPending}
          disabled={isPending}
          onClick={handleDeleteItem}
        >
          {isPending ? 'Deleting...' : 'Delete'}
        </LoadingButton>
      </div>
    </Modal>
  )
}
